export function daysDiffFromNow(unixTime: number): number {
  const now = Math.floor(Date.now() / 1000);
  const diffSeconds = now - unixTime;
  const diffDays = diffSeconds / (60 * 60 * 24);
  return Math.floor(diffDays);
}
